// import Vue from 'vue'
import VueRouter from 'vue-router'
// Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    name:'Home',
    component: resolve => require(['@/view/index'], resolve)
  },

  {
    path: '/asia',
    component: {render: (e) => e("router-view")},
    redirect: '/asia/index',
    children: [
      {
        path: 'index',
        component: resolve => require(['@/view/asia/index'], resolve),
      },
      {
        path: 'about',
        component: resolve => require(['@/view/asia/about'], resolve),
      },
      {
        path: 'serve',
        component: resolve => require(['@/view/asia/serve'], resolve),
      },
      {
        path: 'news',
        component: resolve => require(['@/view/asia/news'], resolve),
      },
      {
        path: 'view/:id',
        component: resolve => require(['@/view/asia/view'], resolve),
      },


    ]
  },

  {
    path: '/america',
    component: {render: (e) => e("router-view")},
    redirect: '/america/index',
    children: [
      {
        path: 'index',
        component: resolve => require(['@/view/america/index'], resolve),
      },
      {
        path: 'about',
        component: resolve => require(['@/view/america/about'], resolve),
      },
      {
        path: 'serve',
        component: resolve => require(['@/view/america/serve'], resolve),
      },
      {
        path: 'case',
        component: resolve => require(['@/view/america/case'], resolve),
      },
      {
        path: 'view/:id',
        component: resolve => require(['@/view/america/view'], resolve),
      },
    ]
  },
  {
    path: '/europe',
    component: {render: (e) => e("router-view")},
    redirect: '/europe/index',
    children: [
      {
        path: 'index',
        component: resolve => require(['@/view/europe/index'], resolve),
      },
      {
        path: 'about',
        component: resolve => require(['@/view/europe/about'], resolve),
      },
      {
        path: 'serve',
        component: resolve => require(['@/view/europe/serve'], resolve),
      },
      {
        path: 'case',
        component: resolve => require(['@/view/europe/case'], resolve),
      },
      {
        path: 'show',
        component: resolve => require(['@/view/europe/show'], resolve),
      },
      {
        path: 'view/:id',
        component: resolve => require(['@/view/europe/view'], resolve),
      },
      {
        path: 'showView/:id',
        component: resolve => require(['@/view/europe/showView'], resolve),
      },
    ]
  },
  {
    path: '/middleEastAfrica',
    component: {render: (e) => e("router-view")},
    redirect: '/middleEastAfrica/index',
    children: [
      {
        path: 'index',
        component: resolve => require(['@/view/middleEastAfrica/index'], resolve),
      },
      {
        path: 'about',
        component: resolve => require(['@/view/middleEastAfrica/about'], resolve),
      },
      {
        path: 'serve',
        component: resolve => require(['@/view/middleEastAfrica/serve'], resolve),
      },
      {
        path: 'case',
        component: resolve => require(['@/view/middleEastAfrica/case'], resolve),
      },
      {
        path: 'view/:id',
        component: resolve => require(['@/view/middleEastAfrica/view'], resolve),
      },
    ]
  },

  // {
  //   path: '/about',
  //   name:'About',
  //   component: resolve => require(['../view/about/index'], resolve)
  // },
]

const router = new VueRouter({
    mode:'history',
	base: '/pc/',
    routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js